import type {EffectiveSubscription} from './effectiveSubscription';

/**
 * Called when a generation is blocked.
 *
 * Past-due subscribers are sent to the past-due modal (buying more is pointless
 * until the failed payment clears). Otherwise: Free/Plus users go to the upgrade
 * paywall; Pro is the top tier and is now credit-capped, so upgrading is a
 * dead-end — we open the top-up modal so they can buy more credits right away.
 */
export function notifyGenerationBlocked(
  effectiveSubscription: EffectiveSubscription | undefined,
  openPaywall: () => void,
  openBuyCredits: () => void,
  openPastDue: () => void,
) {
  if (effectiveSubscription?.isPastDue) {
    openPastDue();
    return;
  }
  if (effectiveSubscription?.tier === 'pro') {
    openBuyCredits();
    return;
  }
  openPaywall();
}
